<template>
    <el-dialog ref="recordDialog" :before-close="handleDialogClose" :close-on-click-modal="false" :title="recordId ? '编辑记录' : '新增记录'" :visible.sync="recordDialog" append-to-body class="custom-form-dialog" width="520px">
        <el-form ref="formData" :model="formData" :rules="formRules" label-position="top" v-loading="loading">
            <el-form-item label="记录日期" prop="created_at">
                <el-date-picker  v-model="formData.created_at" format="yyyy-MM-dd" placeholder="请选择记录日期" type="date" value-format="yyyy-MM-dd"></el-date-picker>
            </el-form-item>
            <el-form-item label="记录内容" prop="content">
                <div
                        id="commentTextarea"
                        ref="commentTextarea"
                        class="commentTextarea"
                        contenteditable="true"
                        @keydown="handleKeyDown"
                        @keyup="handleKeyUp"
                ></div>
            </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button @click.stop="handleDialogClose">取消</el-button>
            <el-button :disabled="BtnDisabled" type="primary" @click.stop="handleDialogConfirm" >确定</el-button>
        </span>
        <AtDialog
                v-if="showDialog"
                :position="position"
                :queryString="queryString"
                :showDialog.sync="showDialog"
                @onHide="handleHide"
                @onPickUser="handlePickUser"
                @onShow="handleShow"
        />
    </el-dialog>
</template>
<script>
import { ProjectLogAdd,ProjectLogDetail,ProjectLogEdit } from "@/api/index.js"
import { getNowDate } from"@/utils";
import AtDialog from "@/components/pComponents/AtDialog";
export default {
    name: "record_tpl",
    components: {
        AtDialog,
    },
    props: {
        recordDialog: {
            type: Boolean,
            default: false
        },
        projectId: {
            type: Number,
            default: 0
        },
        recordId: {
            type: Number,
            default: 0
        },
    },
    data() {
        return {
            BtnDisabled:false,
            formData: {
                created_at:getNowDate(),
                content: "",
            },
            formRules: {
                created_at: [{required: true, message: "请选择记录日期", trigger: 'change'}],
                content: [{required: true, message: "请输入记录内容", trigger: 'change'}],
            },
            placeholderText:'请输入记录内容',
            userList: [],
            loading: false,
            showDialog: false, // 是否显示弹窗
            node: "", // 获取到节点
            endIndex: "", // 光标最后停留位置
            queryString: "", // 搜索值
            position: {
                x: 530,
                y: 300,
            }, // 弹窗显示位置
        }
    },
    created() {
        this.placeholder()
        if(this.recordId){
            this.getProjectLogDetail()
        }
    },
    methods: {
        getProjectLogDetail(){
            this.loading = true
            ProjectLogDetail({id:this.recordId}).then(res => {
                if (res.code === 200) {
                    this.formData.created_at = res.data.created_at
                    this.formData.content = res.data.content.text
                    this.$refs.commentTextarea.innerHTML = res.data.content.text
                    this.placeholder()

                }
                this.loading = false
            })
        },
        handleDialogClose() {
            this.$emit("update:recordDialog", false)
        },
        handleDialogConfirm() {
            this.$refs.formData.validate(valid => {
                if (valid) {
                    let postData = this.getCommentContent()
                    postData.created_at =  this.formData.created_at
                    postData.project_manage_id = this.projectId
                    this.BtnDisabled = true
                    if(this.recordId){
                        postData.id = this.recordId
                        ProjectLogEdit(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: '编辑成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: () => { }
                                })
                                this.$emit("update:recordDialog", false)
                                this.$emit('success')
                            }
                        })
                    }else {
                        ProjectLogAdd(postData).then(res => {
                            if (res.code === 200) {
                                this.$message({
                                    message: '新增成功',
                                    type: 'success',
                                    duration: 1000,
                                    onClose: () => { }
                                })
                                this.$emit("update:recordDialog", false)
                                this.$emit('success')
                            }
                        })
                    }



                }
            })
        },

        placeholder() {
            this.$nextTick(() => {
                var div = document.getElementById("commentTextarea");
                if (div.textContent.trim() === "") {
                    div.setAttribute("data-placeholder", this.placeholderText);
                } else {
                    div.setAttribute("data-placeholder", "");
                }
            });
        },
        getCommentContent() {
            let commentText = this.$refs.commentTextarea.innerHTML;
            const spanArr = this.$refs.commentTextarea.querySelectorAll(".at-button");
            const atPeople = [];
            const at_uid = [];
            if (spanArr.length > 0) {
                spanArr.forEach((item) => {
                    atPeople.push(JSON.parse(item.dataset.user));
                });
                atPeople.forEach((item, key) => {
                    at_uid.push(item.uid);
                });
            }
            return {
                content: commentText,
                at_uid: at_uid.join(","),
                at_people: atPeople,
            };
        },
        // 获取光标位置
        getCursorIndex() {
            const selection = window.getSelection();
            return selection.focusOffset; // 选择开始处 focusNode 的偏移量
        },

        // 获取节点
        getRangeNode() {
            const selection = window.getSelection();
            return selection.focusNode; // 选择的结束节点
        },

        // 弹窗出现的位置
        getRangeRect() {
            let dialogElement = this.$refs.recordDialog.$el;
            const dialogElementRect = dialogElement.getBoundingClientRect();
            const width = dialogElementRect.width;
            const height = dialogElementRect.height;
            const width1 = (width / 2) - (520 / 2)
            const height1 = (height / 2) - (358 / 2)
            const selection = window.getSelection();
            const range = selection.getRangeAt(0); // 是用于管理选择范围的通用对象
            const rect = range.getClientRects()[0]; // 择一些文本并将获得所选文本的范围
            const LINE_HEIGHT = 30;
            return {
                x: rect.x - width1,
                y: rect.y + LINE_HEIGHT - height1,
            };
        },

        // 是否展示 @
        showAt() {
            const node = this.getRangeNode();
            if (!node || node.nodeType !== Node.TEXT_NODE) return false;
            const content = node.textContent || "";
            const regx = /@([^@\s]*)$/;
            const match = regx.exec(content.slice(0, this.getCursorIndex()));
            return match && match.length === 2;
        },

        // 获取 @ 用户
        getAtUser() {
            const content = this.getRangeNode().textContent || "";
            const regx = /@([^@\s]*)$/;
            const match = regx.exec(content.slice(0, this.getCursorIndex()));
            if (match && match.length === 2) {
                return match[1];
            }
            return undefined;
        },

        // 创建标签
        createAtButton(user) {
            const btn = document.createElement("span");
            btn.style.display = "inline-block";
            btn.dataset.user = JSON.stringify(user);
            btn.className = "at-button";
            btn.contentEditable = "false";
            btn.textContent = `@${user.name}`;
            btn.style.color = "#409eff";
            return btn;
        },

        replaceString(raw, replacer) {
            return raw.replace(/@([^@\s]*)$/, replacer);
        },

        // 插入@标签
        replaceAtUser(user) {
            const node = this.node;
            if (node && user) {
                const content = node.textContent || "";
                const endIndex = this.endIndex;
                const preSlice = this.replaceString(content.slice(0, endIndex), "");
                const restSlice = content.slice(endIndex);
                const parentNode = node.parentNode;
                const nextNode = node.nextSibling;
                const previousTextNode = new Text(preSlice);
                const nextTextNode = new Text("\u200b" + restSlice); // 添加 0 宽字符
                const atButton = this.createAtButton(user);
                parentNode.removeChild(node);
                // 插在文本框中
                if (nextNode) {
                    parentNode.insertBefore(previousTextNode, nextNode);
                    parentNode.insertBefore(atButton, nextNode);
                    parentNode.insertBefore(nextTextNode, nextNode);
                } else {
                    parentNode.appendChild(previousTextNode);
                    parentNode.appendChild(atButton);
                    parentNode.appendChild(nextTextNode);
                }
                // 重置光标的位置
                const range = new Range();
                const selection = window.getSelection();
                range.setStart(nextTextNode, 0);
                range.setEnd(nextTextNode, 0);
                selection.removeAllRanges();
                selection.addRange(range);
            }
        },

        // 键盘抬起事件
        handleKeyUp() {
            if (this.showAt()) {
                const node = this.getRangeNode();
                const endIndex = this.getCursorIndex();
                this.node = node;
                this.endIndex = endIndex;
                this.position = this.getRangeRect();
                this.queryString = this.getAtUser() || "";
                this.showDialog = true;
            } else {
                this.showDialog = false;
            }
            this.placeholder()
            var div = document.getElementById("commentTextarea");
            this.formData.content = div.textContent
            this.$refs.formData.validateField('content');
        },

        // 键盘按下事件
        handleKeyDown(e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                const selection = window.getSelection();
                const range = selection.getRangeAt(0);
                const br = document.createElement("br");
                range.insertNode(br);
                range.setStartAfter(br);
                range.collapse(true);
                selection.removeAllRanges();
                selection.addRange(range);
            }
            if (this.showDialog) {
                if (e.code === "ArrowUp" || e.code === "ArrowDown" || e.code === "Enter") {
                    e.preventDefault();
                }
            }

        },

        // 插入标签后隐藏选择框
        handlePickUser(user) {
            this.replaceAtUser(user);
            this.user = user;
            this.showDialog = false;
        },
        // 隐藏选择框
        handleHide() {
            this.showDialog = false;
        },

        // 显示选择框
        handleShow() {
            this.showDialog = true;
        },

    }
}
</script>
<style lang="scss" scoped>
.is-error .commentTextarea{
    border: 1px solid rgb(228, 65, 68);
}
.commentTextarea {
    width: 100%;
    height: 84px;
    display: block;
    padding: 6px 12px;
    line-height: 1.5;
    box-sizing: border-box;
    color: #606266;
    transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
    overflow-y: scroll;
    position: relative;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    &::before {
         content: attr(data-placeholder);
         position: absolute;
         top: 7px;
         left: 14px;
         color: rgb(193, 192, 192);
         pointer-events: none;
     }
}
</style>
